module.exports = __webpack_public_path__ + "img/Naksabazar.153f0d43.png";